import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import type { SessionKeepAlive } from "./createSessionKeepAlive"

// Captured on `window` so element scrolls, which don't bubble, still count.
const ACTIVITY_EVENTS = ["pointerdown", "keydown", "scroll"] as const
const LISTENER_OPTIONS: AddEventListenerOptions = { capture: true, passive: true }

export function useSessionKeepAlive(keepAlive: SessionKeepAlive, isLoggedIn: boolean): void {
  const { pathname } = useLocation()
  const wasLoggedIn = useRef(isLoggedIn)

  useEffect(() => {
    keepAlive.notifyNavigation()
  }, [keepAlive, pathname])

  // A password sign-in at `/` changes no route, so signing in has to resume the keep-alive too.
  useEffect(() => {
    if (isLoggedIn && !wasLoggedIn.current) keepAlive.notifySignIn()
    wasLoggedIn.current = isLoggedIn
  }, [keepAlive, isLoggedIn])

  useEffect(() => {
    const onActivity = (): void => keepAlive.notifyActivity()
    ACTIVITY_EVENTS.forEach((type) => window.addEventListener(type, onActivity, LISTENER_OPTIONS))
    return () => ACTIVITY_EVENTS.forEach((type) => window.removeEventListener(type, onActivity, LISTENER_OPTIONS))
  }, [keepAlive])
}
